<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar :title="headline" :showBackButton="true" :isEdit="false" :buttons="toolbarButtons" @onButton="onToolbarButton"></app-view-toolbar>
    <template v-if="!viewDataIsLoaded">
      <v-skeleton-loader
        type="card-heading, list-item-three-line"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <!--data is loaded-->
      <!--signingStatus ref:
        assignedToDriver
        assigedToOtherDriver
        driverHasSignedAndIsAssignable
        driverCanSign
      -->
      <template
        v-if="viewData.whoIsViewing == 'driver'"
      >
        <!--driver is viewing, evaluate signingStatus-->
        <v-row
          v-if="viewData.signingStatus == 'assignedToDriver'"
        >
          <!--assignment has been assigned to driver-->
          <v-col>
            <v-card
              class="mx-auto"
              color="accent"
              dark="dark"
            >
              <div class="pa-4">
                <div class="text-body">
                  Du erhöll jobbet {{ viewData.signingData.driverAssignedDate }}
                </div>
                <div v-if="!isMobile" class="text-body mt-2">
                  Du når åkeriet på: {{ viewData.signingData.companyContactData.phone }}
                </div>
                <div>
                  <v-btn
                    class="mt-2 mr-2"
                    :href="'mailto:' + viewData.signingData.companyContactData.email"
                    target="_blank"
                  >
                    <v-icon left>mdi-email-outline</v-icon>
                    Maila
                  </v-btn>
                  <v-btn
                    class="mt-2 mr-2"
                    v-if="isMobile"
                    :href="'tel:' + viewData.signingData.companyContactData.phone"
                  >
                    <v-icon left>mdi-phone</v-icon>
                    Ring
                  </v-btn>
                  <v-btn
                    class="mt-2"
                    @click="openAgreement()"
                  >
                    <v-icon left>mdi-glasses</v-icon>
                    Avtal
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          v-else-if="viewData.signingStatus == 'assigedToOtherDriver'"
        >
          <!--assignment has been assigned to another driver-->
          <v-col>
            <v-card
              class="mx-auto"
              color="accent"
              dark="dark"
            >
              <div class="pa-4 text-body">
                Jobbet tillsattes {{ viewData.signingData.assignedDate }}
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          v-else-if="viewData.signingStatus == 'driverHasSignedAndIsAssignable'"
        >
          <!--assignment has been signed by driver-->
          <v-col>
            <v-card
              class="mx-auto"
              color="accent"
              dark="dark"
            >
              <div class="pa-4">
                <div class="text-body">
                  Du signerade jobbet {{ viewData.signingData.driverSignedDate }}
                </div>
                <div>
                  <v-btn
                    class="mt-2"
                    @click="openAgreement()"
                  >
                    <v-icon left>mdi-glasses</v-icon>
                    Avtalsförslag
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template
        v-else-if="viewData.whoIsViewing == 'owner'"
      >
        <!--(assigment) owner is viewing, evaluate signingStatus-->
        <v-row
          v-if="viewData.signingStatus == 'isAssigned'"
        >
          <!---assignment has been assigned-->
          <v-col>
            <v-card
              class="mx-auto"
              color="accent"
              dark="dark"
            >
              <div class="pa-4">
                <div class="text-body">
                  Jobbet har tilldelats: 
                  <span
                    @click="showAssignedDriver()"
                    class="xLink"
                  >{{ viewData.assignmentData.assignedDriverData.name }}</span>
                  <span v-if="!isMobile">
                    som nås på {{ viewData.assignmentData.assignedDriverData.phone }}
                  </span>
                </div>
                <div>
                  <v-btn
                    class="mt-2 mr-2"
                    :href="'mailto:' + viewData.assignmentData.assignedDriverData.email"
                    target="_blank"
                  >
                    <v-icon left>mdi-email-outline</v-icon>
                    Maila
                  </v-btn>
                  <v-btn
                    class="mt-2 mr-2"
                    v-if="isMobile"
                    :href="'tel:' + viewData.assignmentData.assignedDriverData.phone"
                  >
                    <v-icon left>mdi-phone</v-icon>
                    Ring
                  </v-btn>
                  <v-btn
                    class="mt-2"
                    @click="openAgreement()"
                  >
                    <v-icon left>mdi-glasses</v-icon>
                    Avtal
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          v-else-if="viewData.signingStatus == 'hasSignedDrivers'"
        >
          <!---assignment has signed drivers-->
          <v-col>
            <v-card
              class="mx-auto"
              color="accent"
              dark="dark"
            >
              <div class="pa-4 text-body">
                <span
                  class="xLink"
                  @click="showSignedDrivers()"
                >{{ viewData.assignmentData.signedCount }} {{ viewData.assignmentData.signedCount == 1 ? 'chaufför' : 'chaufförer' }}</span>
                har signerat jobbet
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <v-row class="ph-12 pb-6">
        <v-col>
          <!--assignment data-card-->
          <app-data-card :title="viewData.assignmentData.name" :data_ar="viewData.presentationData.assignmentData_ar" mode="view" :dark="false" :color="'blue-grey lighten-5'" class="mb-6"></app-data-card>
          <!--google-map-->
          <app-google-map
            :markers="markers"
            mode="view"
            :data="viewData.mapData"

          ></app-google-map>
        </v-col>
      </v-row>
      <template
        v-if="viewData.signingStatus == 'driverCanSign'"
      >
        <!--driver can sign this assignment - show sign stuff-->
        <v-stepper
          v-model="stepperSignAssigment"
          vertical
        >
          <!--interested?--->
          <v-stepper-step
            step="1"
            :complete="stepperSignAssigment > 1"
            color="accent"
          >
            <span class="text-h6">Intresserad?</span>
          </v-stepper-step>
          <v-stepper-content
            step="1"
          >
            <div class="pb-4">
              Är du intresserad av att anta jobbet?
              <br>
              I så fall kan du skapa och signera ett avtalsförslag. Åkeriet väljer sedan vilken chaufför de vill ge jobbet till genom att signera ditt avtalsförslag.
            </div>
            <v-btn
              color="accent"
              @click="createAgreement()"
            >
              Skapa avtalsförslag
            </v-btn>
          </v-stepper-content>
          <!--approve agreement--->
          <v-stepper-step
            step="2"
            :complete="stepperSignAssigment > 2"
            color="accent"
          >
            <span class="text-h6">Godkänn avtalsförslag</span>
          </v-stepper-step>
          <v-stepper-content
            step="2"
          >
            <v-btn
              class="mb-4"
              color="secondary"
              @click="openAgreement()"
            >
              Öppna avtalsförslag
            </v-btn>
            <v-form ref="formApproveAgreement">
              <v-checkbox
                v-model="acceptTerms"
                :rules="[formRules.checked(acceptTerms, 'Du måste godkänna villkoren')]"
                label="Jag har läst och godkänner villkoren i avtalsförslaget"
              ></v-checkbox>
            </v-form>
            <div class="mt-4">
              <!--bank-id-->
              <app-bank-id
                headline="Signera med BankID"
                mode="sign"
                :message="viewData.bankIdData.message"
                :dialog="showBankIdDialog"
                @close="showBankIdDialog = false"
                @complete="onBankIdComplete"
                :returnUrl="bankIdReturnUrl"
                :bankIdData="viewData.bankIdData"
              ></app-bank-id>
            </div>
            <v-btn
              color="accent"
              large
              @click="signAgreement()"
            >
              Signera avtalsförslag
            </v-btn>
          </v-stepper-content>
          <v-stepper-step
            step="3"
            :complete="stepperSignAssigment > 3"
            color="accent"
          >
            <span class="text-h6">Klart!</span>
          </v-stepper-step>
          <v-stepper-content
            step="3"
          >
            Nu finns du med bland de chaufförer åkeriet kan välja bland. Du meddelas när åkeriet valt chaufför, även om de valt någon annan.
            <div class="pt-4">
              <v-btn
                color="accent"
                @click="onSignOk()"
              >
                OK
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper>
      </template>
    </template>
    <!--loader-->
    <v-overlay
      :value="loader"
      opacity="0.8"
      z-index="1001"
    >
      <v-progress-circular
        :size="80"
        color="secondary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import GoogleMap from '../components/GoogleMap'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { googleMapMixin } from '../mixins/googleMap'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'
import DataCard from '../components/DataCard'

export default {
  name: 'Assignment',
  components: {
    'app-bank-id': () => import('../components/BankId'),//lazy load BankID
    'app-snack-bar': SnackBar,
    'app-google-map': GoogleMap,
    'app-data-card': DataCard,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin, googleMapMixin],
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      viewData: {},
      headline: 'Jobb',
      viewDataIsLoaded: false,
      acceptTerms: false,
      stepperSignAssigment: 1,
      agreementFileData: null,
      loader: false,
      markers: [
        {
          label: 'startPos',
          position: null,
          name: 'Start',
          icon: {
            url: require('../assets/markers/start.png'),
            scaledSize: {width: 64, height: 64},
            labelOrigin: {x: 16, y: -10}
          }
        },
        {
          label: 'endPos',
          position: null,
          name: 'Mål',
          icon: {
            url: require('../assets/markers/goal.png'),
            scaledSize: {width: 64, height: 64},
            labelOrigin: {x: 16, y: -10}
          }
        }
      ],
      bankIdReturnUrl: '',
      showBankIdDialog: false,
      bankIdToken: null
    }
  },
  computed: {
    ...mapGetters(['access_token', 'loggedInData']),
    isDriver() {
      return this.loggedInData.agentData.type == 'driver'
    },
    toolbarButtons() {
      if (this.viewDataIsLoaded && this.viewData.whoIsViewing == 'owner' && this.viewData.signingStatus == 'hasNoDrivers') {
        return [
          {
            label: 'edit',
            icon: 'pencil',
            title: 'Redigera jobb'
          }
        ]
      }
      return []
    }
  },
  watch: {
    viewDataIsLoaded(value) {
      if (value) {
        //set headline
//        this.headline = (this.isNew) ? 'Nytt jobb' : 'Redigera jobb'
        //possibly update positions in markerData
        let label, position
        for (let marker of this.markers) {
          label = marker.label
          position = this.viewData.mapData[label]
          if (position.lat !== 0 && position.lng !== 0) {
            //label has real position, update marker in markers (that is invoked in google-map)
            marker.position = position
          }
        }
      }
    }
  },
  methods: {
    createAgreement() {
      this.loader = true
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      //post data to API
      let postData = {
        agentData: this.loggedInData.agentData,
        asgUuid: this.uuid
      }
      let url = this.url_composeApiUrl('/assignment/createAgreement')
//      console.log('post', url)
//      console.log('post', postData)
      axios.post(url, postData, config)
        .then(response => {
//          console.log('post response', response)
          this.loader = false
          if (response.data.success) {
            //success
            this.agreementFileData = response.data.returnData.agreementFileData
            //now that the agreement file is created, we can update the this.viewData.bankIdData.hiddenData
            this.viewData.bankIdData.hiddenData = response.data.returnData.bankIdHiddenData
            this.stepperSignAssigment = 2
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    },
    onViewData(viewData) {
      this.viewData = viewData
      if (this.viewData.agreementFileData) {
        this.agreementFileData = this.viewData.agreementFileData
      }
      this.viewDataIsLoaded = true
    },
    openAgreement() {
      let cachelessUrl = this.url_composeCachelessUrl(this.agreementFileData.url)
//      console.log(cachelessUrl)
      window.open(cachelessUrl)
    },
    signAgreement() {
      const formIsValid = this.$refs.formApproveAgreement.validate()
      if (formIsValid) {
        this.showBankIdDialog = true
      }
    },
    showAssignedDriver() {
      this.$router.push({ name: 'driver', params: { uuid: this.viewData.assignmentData.assignedDriverData.uuid }, query: { asgUuid: this.uuid } })
    },
    showSignedDrivers() {
      this.$router.push({ name: 'signed-drivers', params: { id: this.viewData.assignmentData.id } })
    },
    onBankIdComplete() {
//      console.log("Assignment - onBankIdComplete", token)
      this.showBankIdDialog = false
      this.stepperSignAssigment = 3
    },
    onToolbarButton(button) {
      switch (button.label) {
        case 'edit':
          this.editAssignment()
          break
      }
    },
    editAssignment() {
      this.$router.push({ name: 'assignment-edit', params: { id: this.viewData.assignmentData.id } })
    },
    onSignOk() {
      this.$router.replace({ name: 'driver-dashboard'})
    }
  },
  created() {
    //get view data
    let config = {
      headers: {
        'Authorization': this.access_token
      }
    }
    //post data to API
    let postData = {
      //post agentData in order to return specific data depending on "who's watching"
      agentData: this.loggedInData.agentData
    }
    let url = this.url_composeApiUrl('/assignment/' + this.uuid)
//    console.log('post', url)
    axios.post(url, postData, config)
      .then(response => {
//        console.log('post response', response)
        if (response.data.success) {
          //success
          this.onViewData(response.data.returnData.viewData)
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>

<style>

</style>